import { Link } from "@components/Link";
import {
  NAV_ICON_ACTIVE_COLOR_CLASSNAME,
  NAV_ICON_COLOR_CLASSNAME,
} from "@constants/layout";
import type { SVGProps } from "@lyteflo/types";
import type { ComponentChildren } from "preact";
import { useLocation } from "wouter";

interface NavItemProps {
  path: string;
  label: string;
  Icon?: SVGProps;
  iconClassName?: string;
  iconColorClassName?: string;
  active?: boolean;
  children?: ComponentChildren;
  className?: string;
}

export const NavItem = ({
  path,
  label,
  Icon,
  iconClassName = "",
  iconColorClassName,
  active: activeProp,
  children,
  className,
}: NavItemProps) => {
  const [location] = useLocation();
  const active =
    activeProp ?? (location === path || location.startsWith(`${path}/`));
  const iconColor =
    iconColorClassName ??
    (active ? NAV_ICON_ACTIVE_COLOR_CLASSNAME : NAV_ICON_COLOR_CLASSNAME);

  return (
    <div className={className}>
      <Link
        href={path}
        color="gray"
        className={`lf-flex lf-items-center lf-gap-2 lf-px-4 lf-py-2 lf-rounded-md lf-whitespace-nowrap ${
          active ? "lf-bg-[var(--gray-4)]" : "hover:lf-bg-[var(--gray-4)]"
        }`}
        underline="none"
      >
        {Icon && (
          <Icon
            className={`lf-shrink-0 lf-block lf-w-6 lf-h-6 ${iconColor} ${iconClassName}`}
          />
        )}
        <span className={"lf-text-[var(--gray-12)]"}>{label}</span>
        {children}
      </Link>
    </div>
  );
};
